import React, { Fragment } from 'react'

import { tr } from 'pmt-modules/i18n'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import Chip from '@material-ui/core/Chip'

import { findOnArray } from 'pmt-utils/array'

import { getAllergensOptions } from '../../constants'

const AllergenChooser = ({ value, onChange, limitTags = -1, ...otherProps }) => {
  const allergensOptions = getAllergensOptions()

  return (
    <Autocomplete
      fullWidth
      multiple
      limitTags={limitTags}
      options={allergensOptions}
      disableCloseOnSelect
      getOptionLabel={({ label }) => label}
      renderOption={(option, { selected }) => (
        <Fragment>
          <Checkbox size="small" style={{ marginRight: 8 }} checked={selected} color="primary" />
          {option.label}
        </Fragment>
      )}
      renderInput={params => (
        <TextField {...params} variant="standard" label={tr('global.allergen.chooser.label')} />
      )}
      renderTags={(tag, getTagProps) =>
        tag.map((option, index) => (
          <Chip {...getTagProps({ index })} icon={option.icon} label={option.label} />
        ))
      }
      onChange={(e, newValues) => {
        onChange(newValues.map(({ value }) => value))
      }}
      value={value.map(v => findOnArray(allergensOptions, option => option.value === v))}
      {...otherProps}
    />
  )
}
export default AllergenChooser
